import { ControlInterface } from '../../types/FormJson';
import { ReduxComponentInterface } from '../../../../types/Global';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { transitionSubmit } from '../../actions/form';
import Button from '../../../Button';

interface TransitionsProps extends ControlInterface, ReduxComponentInterface {
	formInstanceId: string;
	innerFormInstanceId?: string;
}

class Transitions extends React.PureComponent<TransitionsProps> {
	onClick = (event: React.MouseEvent) => {
		event.preventDefault();
		const { actions, formInstanceId, name, value, onChange, innerFormInstanceId } = this.props;
		onChange([name], value, true);
		actions.transitionSubmit(formInstanceId, true, innerFormInstanceId);
	};

	render() {
		const { value, disabled } = this.props;

		return (
			<div className={`form-row row-${name}`}>
				<Button label={value.split('|')[1]} onClick={this.onClick} disabled={disabled} />
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ transitionSubmit }, dispatch),
});

export default connect(null, mapDispatchToProps)(Transitions);
